/**
 * Handle Animation
 */

import { $window } from '../utils/globals';

const handleVideoAnimation = () => {
	const $container = $('.js-hero-animation');

	if (! $container.length > 0) {
		return;
	}

	startAnimation();
}

/**
 * Start Animation
 */
const startAnimation = () => {
	const $container = $('.js-hero-animation');

	$container.on('update:visible-logo-and-field', () => {
		setTimeout(() => {
			visibleBorder();
		}, 1000);
	}).on('update:visible-border', () => {
		setTimeout(() => {
			insertTextAnimation($container.find('.hero__letter').first());
		}, 0);
	});

	setTimeout(() => {
		visibleLogoAndField()
	}, 200)
}

/**
 * Add active class on elements in animation
 */
const visibleLogoAndField = () => {
	const $container = $('.js-hero-animation');

	$container
		.find('.hero__box')
		.addClass('is-visible');

	$container
		.find('.hero__edit')
		.addClass('is-visible');

	$container.trigger('update:visible-logo-and-field');
}

/**
 * Add active class on border
 */
const visibleBorder = () => {
	const $container = $('.js-hero-animation');

	$container
		.find('.hero__box-border')
		.addClass('is-visible');

	$container
		.find('.hero__box')
		.addClass('blinking');

	$container.trigger('update:visible-border');
}



/**
 * Insert text animation
 * @param  {[object]} $field
 * @param  {[string]} text
 */
const insertTextAnimation = ($letter) => {
	const $nextLetter = $letter.next();

	$letter.addClass('hero__letter--added');

	if ($nextLetter.length > 0) {
		setTimeout(function() {
			insertTextAnimation($nextLetter);
		}, 50);
	}


	if (!($nextLetter.length > 0) && $letter.closest('.hero__row').next('.hero__row').length > 0) {
		const $letterNextRow = $letter.closest('.hero__row').next('.hero__row').find('.hero__letter').first();

		insertTextAnimation($letterNextRow);

		const $nextRowLetterNext = $letterNextRow.next();

		if ($nextRowLetterNext.length > 0) {
			setTimeout(function() {
				insertTextAnimation($nextRowLetterNext);
			}, 50);
		}
	}
}

handleVideoAnimation();
